import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trix"
export default class extends Controller {
  connect() {
    this.observeToolbar()
  }

  observeToolbar() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE && node.matches("[id^='trix-toolbar']")) {
              this.removeAttachmentButton(node)
            }
          })
        }
      })
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }

  removeAttachmentButton(toolbar) {
    const attachButton = toolbar.querySelector(".trix-button-group--file-tools")
    if (attachButton) {
      attachButton.remove()
    }
  }
}
